import {isEmpty} from 'lodash';
import {Injectable} from '@angular/core';
import {PortfolioService} from '../../service/portfolio.service';
import {PreferredCategories} from '../../model/portfolio-preferences.model';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {ManualInvestPortfolioCreationData} from '../../model/portfolio-creation-data/manual-invest-portfolio-creation-data.model';
import {PreferencesService} from '../../service/preferences.service';
import {StorageService, Keys} from '../../service/storage.service';

export interface PortfolioPreferenceResolverData {
    investmentAmount: number;
    numberOfLoansSelected: number;
    pendingAmountToInvest: number;
    preferredCategories: PreferredCategories[];
    defaultPreferredCategories: PreferredCategories[];
}

@Injectable()
export class PortfolioPreferenceResolver implements Resolve<PortfolioPreferenceResolverData> {
    private readonly portfolioService: PortfolioService;
    private readonly preferencesService: PreferencesService;
    private readonly storageService: StorageService;

    constructor(portfolioService: PortfolioService, preferencesService: PreferencesService, storageService: StorageService) {
        this.preferencesService = preferencesService;
        this.portfolioService = portfolioService;
        this.storageService = storageService;
    }

    public async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PortfolioPreferenceResolverData> {
        const tempPortfolioId = route.params.tempPortfolioId;
        const portfolioCreationData = await this.portfolioService.getLocalPortfolioCreationData(tempPortfolioId) as ManualInvestPortfolioCreationData;
        const amountInvested = portfolioCreationData.selectedInvestments.map(i => i.amount).reduce((acc, val) => acc += val, 0);
        const pendingAmount = portfolioCreationData.portfolioAmount - amountInvested;
        const preferredCategories = isEmpty(portfolioCreationData.portfolioPreference) ? [] : portfolioCreationData.portfolioPreference;
        const preferences = await this.preferencesService.getUserPreferences(this.storageService.getItem(Keys.PROFILE_ID));
        return {
            pendingAmountToInvest: pendingAmount,
            investmentAmount: portfolioCreationData.portfolioAmount,
            preferredCategories: preferredCategories,
            numberOfLoansSelected: portfolioCreationData.selectedInvestments.length,
            defaultPreferredCategories: <PreferredCategories[]>[{ratingList: Array.from(preferences.preferredRatings)}]
        };
    }
}